module.exports = __webpack_public_path__ + "img/target1.f6bf2e23.jpg";